import React from 'react'
import classNames from "classnames";
import Style from './FJExportResolutionItem.module.less'
import PropTypes from 'prop-types';

function FJExportResolutionItem(props) {

    const {isSelected, shouldAnimation, resolution, ratioType, levelText, resolutionText, src, index} = props;
    const {onClick, onRenderCheckIcon} = props;
    const _onClick = () => {
        onClick(resolution)
    };

    return (
        <div className={
            classNames(
                Style.box,
                {
                    [Style.selected]: isSelected,
                    [Style['c-export-quality-item-animation1']]: shouldAnimation && index === 0,
                    [Style['c-export-quality-item-animation2']]: shouldAnimation && index === 1,
                    [Style['c-export-quality-item-animation3']]: shouldAnimation && index === 2,
                    [Style['c-export-quality-item-active']]: !shouldAnimation,
                },
            )}
             onClick={_onClick}>
            <img className={classNames(Style.preview_img, Style[`image_${ratioType}`])} src={src}/>
            <div className={Style.icon_box}>{isSelected && onRenderCheckIcon()}</div>
            <div className={Style.label}>
                <div className={Style.label__text}>
                    {resolutionText}
                    {levelText && <div className={Style.level_text}>{levelText}</div>}
                </div>
            </div>
        </div>
    );
}

FJExportResolutionItem.propTypes = {
    isSelected: PropTypes.bool,
    shouldAnimation: PropTypes.bool,
    resolution: PropTypes.string.isRequired,
    ratioType: PropTypes.string.isRequired,
    levelText: PropTypes.string.isRequired,
    resolutionText: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    onRenderCheckIcon: PropTypes.func.isRequired,
}

export default FJExportResolutionItem;